export default __webpack_public_path__ + "static/media/020-sun.98f4b583.svg";